import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16">
      <div className="max-w-md w-full text-center rounded-lg border border-border bg-[#18181B] p-10">
        <XCircle className="w-12 h-12 text-destructive mx-auto mb-6" />
        <h1 className="font-display text-3xl font-bold mb-2">Betaling annulleret</h1>
        <p className="text-muted-foreground mb-6">Ingen penge er trukket.</p>
        <Button onClick={() => navigate('/payment')} className="bg-volt text-black hover:bg-volt font-semibold" data-testid="back-to-payment-btn">
          Tilbage til betaling
        </Button>
      </div>
    </div>
  );
}
